import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CompareAndUpdateCandidateDetailsComponent } from './compare-and-update-candidate-details.component';
import { CompareAndUpdateCandidateDetailsModalComponent } from './compare-and-update-candidate-details-modal/compare-and-update-candidate-details-modal.component';

@NgModule({
  declarations: [CompareAndUpdateCandidateDetailsComponent, CompareAndUpdateCandidateDetailsModalComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [CompareAndUpdateCandidateDetailsComponent, CompareAndUpdateCandidateDetailsModalComponent],
  entryComponents: [CompareAndUpdateCandidateDetailsComponent, CompareAndUpdateCandidateDetailsModalComponent]
})
export class CompareAndUpdateCandidateDetailsModule { }
